"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaLancamento = exports.yupLancamento = void 0;
const yup = __importStar(require("yup"));
const utils_1 = require("../utils");
exports.yupLancamento = yup.object({
    idEmpresa: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .positive()
        .integer()
        .default(null)
        .nullable()
        .label('Empresa'),
    idPlanoDebita: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .integer()
        .default(null)
        .nullable()
        .label('Plano Conta - Debita'),
    idPlanoCredita: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .integer()
        .default(null)
        .nullable()
        .label('Plano Conta - Credita'),
    idHistoricoPadrao: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .integer()
        .default(null)
        .nullable()
        .label('Historico Padrao'),
    data: (0, utils_1.sge2Date)().nullable().default(null).label('Data'),
    hora: yup.string().default('').max(6, 'Máximo de 6 caracteres').label('Hora'),
    historico: yup.string().default('').max(4, 'Máximo de 4 caracteres').label('Historico Padrao'),
    complemento: yup.string().default('').max(100, 'Máximo de 100 caracteres').label('Complemento do Historico Padrao'),
    conta: yup.string().default('').max(8, 'Máximo de 8 caracteres').label('Conta'),
    documento: yup.string().default('').max(12, 'Máximo de 12 caracteres').label('Documento'),
    check: yup.boolean().required().default(false).label('Check'),
    debite: yup.string().default('').max(9, 'Máximo de 9 caracteres').label('Plano Conta - Debita'),
    credite: yup.string().default('').max(9, 'Máximo de 9 caracteres').label('Plano Conta - Credita'),
    valor: yup.number().required().label('Valor'),
    tipo: yup.string().default('').max(1, 'Máximo de 1 caracteres').label('Tipo'),
    registro: yup.number().notRequired().label('Registro'),
    referencia: yup.string().default('').max(4, 'Máximo de 4 caracteres').label('Referencia'),
    usuario: yup.string().default('').max(3, 'Máximo de 3 caracteres').label('Usuario'),
    loteBaixa: yup.number().notRequired().label('Lote da Baixa'),
});
exports.schemaLancamento = exports.yupLancamento.shape({});
